<template>
    <div class="percent-wrap">
        <div class="hori">
            <div class="vert-line">
                <div class="line" v-for='i in 4' :key='i'>s</div>
            </div>
            <div class="percent-default">
                <div class="percent" :style='{width: val + "%", backgroundImage: `linear-gradient(90deg, ${color[0]} 0%, ${color[1]} 100%)`}'>
                    <div class="location" :style='{backgroundImage: "url(" + require(`../../assets/location${colorName}.svg`) + ")"}'></div>
                    <div class="number" :style='{color: color[1]}'>{{val}}%</div>
                </div>
            </div>
        </div>
        <div class="vert">
            <div class="percent-default">
                <div class="percent-table">
                    <div class="percent" :class='{ max: val > 95 }' :style='{height: val + "%", backgroundImage: `linear-gradient(0deg, ${color[0]} 0%, ${color[1]} 100%)`}'>
                        <div class="location" :style='{backgroundImage: "url(" + require(`../../assets/location${colorName}.svg`) + ")"}'></div>
                        <div class="number" :style='{color: color[1]}'>{{val}}%</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [ 'val', 'color', 'colorName' ]
}
</script>

<style>

.percent-wrap { width: 80%; margin: auto; margin-top: 30px; }

.percent-wrap .hori .percent-default { width: 100%; height: 7px; background-color: #eeeeee; border-radius: 10px; }
.percent-wrap .hori .vert-line { width: 100%; font-size: 0; margin-bottom: 8px; padding: 0 5px; box-sizing: border-box; }
.percent-wrap .hori .vert-line .line { width: 25%; border-right: 1px solid #9e9e9e; box-sizing: border-box; height: 9px; display: inline-block; }
.percent-wrap .hori .vert-line .line:first-child { border-left: 1px solid #9e9e9e;  }

.percent-wrap .hori .percent-default .percent { position: relative; top: -1px; width: 10%; height: 9px; margin-top: -2px; margin-bottom: -2px; border-radius: 10px; transition: width 1s ease; min-width: 5px; }
.percent-wrap .hori .percent-default .percent .number { position: absolute; top: 20px; right: -50px; width: 100px; text-align: center; font-size: 22px; font-weight: 500; }
.percent-wrap .hori .percent-default .percent .location { position: absolute; bottom: 20px; right: -9px; width: 18px; height: 25px; }

.percent-wrap .vert { display: none; }
@media screen and (max-width: 640px)  {
    .percent-wrap .hori { display: none; }
    .percent-wrap .vert { display: block; position: absolute; top: 0; right: 9vw; bottom: 0; }

    .percent-wrap .vert .percent-default { height: 100%; display: table; position: relative; }
    .percent-wrap .vert .percent-default:before { position: absolute; left: 4px; top: 0; width: 2px; height: 100vh; background-color: #eeeeee; content: ''; }

    .percent-wrap .vert .percent-default .percent-table { height: 100vh; vertical-align: bottom; display: table-cell; }
    .percent-wrap .vert .percent-default .percent-table .percent { position: relative; left: -0px; width: 10px; min-height: 20px; height: 9px; transition: height 1s ease; min-width: 5px;}
    .percent-wrap .vert .percent-default .percent-table .percent .number { position: absolute; top: -12px; right: 43px; width: 100px; text-align: right; font-size: 17px; font-weight: 500; line-height: 25px; }
    .percent-wrap .vert .percent-default .percent-table .percent .location { position: absolute; right: 20px; top: -12px; width: 19px; height: 13px; transform: rotateZ(-90deg); background-size: contain; background-repeat: no-repeat; }
   
    .percent-wrap .vert .percent-default .percent-table .percent.max .number { top: 12px; }
    .percent-wrap .vert .percent-default .percent-table .percent.max .location { top: 10px; }

}



</style>
